export const courtStations = [
  {
    value: 'PARAÑAQUE CITY',
    label: 'PARAÑAQUE CITY',
  },
  {
    value: 'MAKATI CITY',
    label: 'MAKATI CITY',
  },
  {
    value: 'MARIKINA CITY',
    label: 'MARIKINA CITY',
  },
  {
    value: 'MANDALUYONG CITY',
    label: 'MANDALUYONG CITY',
  },
  {
    value: 'PASIG CITY',
    label: 'PASIG CITY',
  },
  {
    value: 'CALOOCAN CITY',
    label: 'CALOOCAN CITY',
  },
  {
    value: 'LAS PIÑAS CITY',
    label: 'LAS PIÑAS CITY',
  },
  {
    value: 'MANILA CITY',
    label: 'MANILA CITY',
  },
  {
    value: 'MUNTINLUPA CITY',
    label: 'MUNTINLUPA CITY',
  },
  {
    value: 'NAVOTAS CITY',
    label: 'NAVOTAS CITY',
  },
  {
    value: 'MALABON CITY',
    label: 'MALABON CITY',
  },
  {
    value: 'PATEROS CITY',
    label: 'PATEROS CITY',
  },
  {
    value: 'SAN JUAN CITY',
    label: 'SAN JUAN CITY',
  },
  {
    value: 'TAGUIG CITY',
    label: 'TAGUIG CITY',
  },
  {
    value: 'VALENZUELA CITY',
    label: 'VALENZUELA CITY',
  },
  {
    value: 'PASAY CITY',
    label: 'PASAY CITY',
  },
  {
    value: 'QUEZON CITY',
    label: 'QUEZON CITY',
  },
  {
    value: 'MALABON CITY',
    label: 'MALABON CITY',
  },
  {
    value: 'SAN MATEO',
    label: 'SAN MATEO',
  },
  {
    value: 'ANGONO',
    label: 'ANGONO',
  },
  {
    value: 'BINANGONAN',
    label: 'BINANGONAN',
  },
  {
    value: 'CAINTA',
    label: 'CAINTA',
  },
  {
    value: 'CARDONA',
    label: 'CARDONA',
  },
  {
    value: 'MORONG',
    label: 'MORONG',
  },
  {
    value: 'RODRIGUEZ',
    label: 'RODRIGUEZ',
  },
  {
    value: 'TANAY',
    label: 'TANAY',
  },
  {
    value: 'TAYTAY',
    label: 'TAYTAY',
  },
]
